<template>
  <div class="card">
    <h2>资讯管理</h2>
    <button class="btn-add" @click="openDialog()">添加资讯</button>
    <table class="nav-table" border="1" cellpadding="8" cellspacing="0">
      <thead>
        <tr>
          <th>ID</th>
          <th>标题</th>
          <th>封面图</th>
          <th>正文预览</th>
          <th>收藏数</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in tableData" :key="item.id">
          <td>{{item.id}}</td>
          <td>{{item.title}}</td>
          <td>
            <img v-if="item.cover" :src="baseUrl + item.cover" style="width:80px;height:auto"/>
            <span v-else>无图</span>
          </td>
          <td style="max-width:240px;word-break:break-all;">{{ getContentPreview(item.content) }}</td>
          <td>{{item.collect_num}}</td>
          <td>
            <button @click="openDialog(item)">编辑</button>
            <button @click="handleDel(item.id)">删除</button>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="dialogVisible" class="dialog-mask" @click.self="dialogVisible=false">
      <div class="dialog-box">
        <h3>{{form.id ? '编辑资讯' : '新增资讯'}}</h3>
        <div class="form-item">
          <label>标题</label>
          <input v-model="form.title" type="text" placeholder="请输入资讯标题"/>
        </div>
        <div class="form-item">
          <label>封面图片</label>
          <input ref="fileInput" type="file" accept="image/*" @change="onFileChange"/>
          <div v-show="showTip" style="color:#ff7d00;margin:10px 0;font-size:14px;">⚠️ 已选中图片，请点击【保存】完成上传！</div>
          <img v-if="form.cover" :src="baseUrl + form.cover" style="width:120px;margin-top:8px;">
        </div>
        <div class="form-item">
          <label>正文内容</label>
          <textarea v-model="form.content" rows="8" placeholder="资讯详细内容"></textarea>
        </div>
        <div class="btn-group">
          <button @click="dialogVisible=false">取消</button>
          <button @click="handleSave">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:"NewsManage",
  data(){
    return{
      baseUrl:"https://asdf.hbbtfbf.cn",
      tableData:[],
      dialogVisible:false,
      showTip:false,
      fileRaw:null,
      form:{
        id:"",
        title:"",
        cover:"",
        content:""
      }
    }
  },
  mounted(){
    this.getList()
  },
  methods:{
    getContentPreview(str){
      if(!str) return ''
      let cleanStr = str.replace(/<[^>]+>/g, ''); // 简单去除html标签
      if(cleanStr.length > 60){
        return cleanStr.slice(0,60)+'...'
      }
      return cleanStr
    },
    async getList(){
      try{
        const res = await this.$request.post("action.php", "act=newsList", {
          headers: { "Content-Type": "application/x-www-form-urlencoded" }
        })
        if(res.code===200){
          this.tableData = res.data
        }
      }catch(e){
        console.error("获取列表失败：",e)
      }
    },
    openDialog(row=null){
      this.dialogVisible = true
      this.showTip = false
      this.fileRaw = null
      if(row){
        this.form.id = row.id
        this.form.title = row.title
        this.form.cover = row.cover
        this.form.content = row.content
      }else{
        this.form = { id:"", title:"", cover:"", content:"" }
      }
    },
    onFileChange(e){
      this.fileRaw = e.target.files[0]
      this.showTip = true
    },
    async handleSave(){
      try{
        if(!this.form.title){
          alert("请填写标题")
          return
        }
        if(this.fileRaw){
          const fd = new FormData()
          fd.append("file", this.fileRaw)
          const uploadRes = await this.$request.post('action.php?act=upload', fd)
          if(uploadRes.code===200){
            this.form.cover = uploadRes.data.imgUrl
          }else{
            alert(uploadRes.msg)
            return
          }
        }
        const act = this.form.id ? "editNews" : "addNews"
        const params = `act=${act}&id=${this.form.id||0}&title=${encodeURIComponent(this.form.title)}&cover=${this.form.cover}&content=${encodeURIComponent(this.form.content)}`
        const res = await this.$request.post("action.php", params, {
          headers: { "Content-Type": "application/x-www-form-urlencoded" }
        })
        if(res.code===200){
          alert(res.msg)
          this.dialogVisible = false
          this.getList()
        }else{
          alert(res.msg)
        }
      }catch(e){
        console.error("保存资讯报错：",e)
      }
    },
    async handleDel(id){
      try{
        if(!confirm("确定删除这条资讯？")) return
        const params = `act=delNews&id=${id}`
        const res = await this.$request.post("action.php", params, {
          headers: { "Content-Type": "application/x-www-form-urlencoded" }
        })
        if(res.code===200){
          alert(res.msg)
          this.getList()
        }else{
          alert(res.msg)
        }
      }catch(e){
        console.error("删除资讯报错：",e)
      }
    }
  }
}
</script>
<style scoped>
.card{padding:20px;}
.btn-add{margin-bottom:12px;padding:6px 12px;cursor:pointer;}
.nav-table{width:100%;border-collapse: collapse;}
/* 弹窗遮罩：不再全屏黑屏，只在卡片区域内显示 */
.dialog-mask{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
}
/* 白色弹窗框 */
.dialog-box{
  background: #fff;
  padding: 24px;
  width: 560px;
  max-width: 92vw;
  border-radius: 6px;
  max-height: 86vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
}
.form-item{margin:12px 0;}
.form-item label{display:block;margin-bottom:4px;}
input,textarea{width:100%;box-sizing:border-box;padding:6px;}
.btn-group{margin-top:16px;display:flex;gap:10px;justify-content:flex-end;}
</style>
